import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import ThemeDto from '../../../administration/dto/ThemeDto'
import AdministrationAction from '../../../administration/actions/AdministrationAction'
import AppStore from '../../../store/AppStore'
import { PATH_RESEARCH } from '../../../home/constants/HomeConstants'
import DtoFilterType from '../../../referential/dto/DtoFilterType'
import SitesAction from '../../../sites/actions/SitesAction'
import DtoUser from '../../../home/dto/DtoUser'
import { ApplicationUtil } from '../../../utils/ApplicationUtil'
import { ACTION_ADVANCED_RESEARCH, ACTION_RESEARCH, CATEGORY_RESEARCH } from '../../../utils/ApplicationConstants'
import i18n from 'simple-react-i18n'
import { filter, flatten } from 'lodash'
import ResearchBarPanel from '../../../research/components/ResearchBarPanel'
import { HOME_PAGE_RESEARCH } from '../../../sites/constants/SitesConstants'

class ResearchPanel extends Component {
	componentWillMount() {
		AppStore.dispatch(AdministrationAction.fetchThemes())
	}

	getDefaultTheme = allReferencialThemes => {
		const allThemes = flatten(allReferencialThemes.map(o => o.themes))
		const filterTheme = filter(allThemes, (o) => {
			return !o.disable
		})
		return filterTheme.map((o) => {
			return {
				label: o.title,
				value: o
			}
		})
	}

	componentWillReceiveProps(nexprops) {
		if (!nexprops.selectedThemes.length && nexprops.themes.length) {
			const initDefaultTheme = this.getDefaultTheme(nexprops.themes)
			AppStore.dispatch(AdministrationAction.selectedThemes(initDefaultTheme))
		}
	}

	researchClick = () => {
		if (this.props.selectedFilters.length) {
			ApplicationUtil.sumbitRegister(CATEGORY_RESEARCH, ACTION_RESEARCH, i18n.searchLaunch)
			SitesAction.launchResearch(this.props.selectedFilters, this.props.selectedThemes, this.props.filterTypes)
		} else {
			ApplicationUtil.sumbitRegister(CATEGORY_RESEARCH, ACTION_ADVANCED_RESEARCH, i18n.advancedSearch)
			AppStore.dispatch(push(`${ PATH_RESEARCH }/open`))
		}
	}

	render() {
		return (
			<div className='col s12 center-align'>
				<div className='row no-margin valign-wrapper'>
					<div className='col s8 offset-s2 center-align no-padding'>
						<div className='row no-margin valign-wrapper'>
							<div className='col s12 no-padding'>
								<ResearchBarPanel isResearchMap={ this.props.isResearchMap }
												  researchClick={ this.researchClick }
												  isLogged={ this.props.isLogged } page={ HOME_PAGE_RESEARCH }/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

ResearchPanel.propTypes = {
	isLogged: PropTypes.bool,
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	selectedThemes: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.instanceOf(ThemeDto)
	})),
	isResearchMap: PropTypes.bool,
	themes: PropTypes.arrayOf(PropTypes.instanceOf(ThemeDto)),
	filterTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoFilterType)),
	user: PropTypes.instanceOf(DtoUser)
}
ResearchPanel.defaultProps = {
	isResearchMap: false
}

const mapStateToProps = store => {
	return {
		selectedFilters: store.AdministrationReducer.selectedFilters,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		themes: store.AdministrationReducer.themes,
		filterTypes: store.ReferentialReducer.filterTypes,
		user: store.HomeReducer.user
	}
}

export default connect(mapStateToProps)(ResearchPanel)



// WEBPACK FOOTER //
// ./src/dashboard/components/research/ResearchPanel.js